import { render, staticRenderFns } from "./product-gallery-recomendations.vue?vue&type=template&id=b78fc180&"
import script from "./product-gallery-recomendations.vue?vue&type=script&lang=js&"
export * from "./product-gallery-recomendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b78fc180')) {
      api.createRecord('b78fc180', component.options)
    } else {
      api.reload('b78fc180', component.options)
    }
    module.hot.accept("./product-gallery-recomendations.vue?vue&type=template&id=b78fc180&", function () {
      api.rerender('b78fc180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product-gallery-recomendations/product-gallery-recomendations.vue"
export default component.exports